import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/workSummary/workOrders`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/workSummary/workOrders`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/workSummary/workOrders`;
